import type { ApiError } from "../api.js";
import styles from "./Loading.module.css";

/**
 * The two states every wired screen has and a fixture never did.
 *
 * Both are stated in the interface's own voice — Plex Mono, no spinner, no skeleton shimmer. The
 * design owns ~520ms of animation and spends all of it on the rate loop (design/README.md
 * §Motion): "no spinners" is a rule, not an omission.
 */

export function Loading({ what }: { what: string }) {
  return (
    <div className={styles.state} data-testid="loading">
      LOADING {what.toUpperCase()}
    </div>
  );
}

export function Failed({ error, retry }: { error: ApiError; retry?: () => void }) {
  return (
    <div className={styles.state} data-testid="load-error">
      <span className={styles.error}>{error.message.toUpperCase()}</span>
      {retry && (
        <button type="button" className={styles.retry} onClick={retry}>
          Try again
        </button>
      )}
    </div>
  );
}

/** Nothing here yet, and a reason why — never a blank page. */
export function Empty({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className={styles.empty} data-testid="empty">
      <div className={styles.emptyTitle}>{title}</div>
      {hint && <div className={styles.emptyHint}>{hint}</div>}
    </div>
  );
}
